import type {
  PositionAnalysisResponse,
  PositionResponse,
} from "@patent-studio/api-types";

/**
 * Whether a position needs the attorney's decision before it can be
 * confirmed, as the server rules it: only Not novel does. The decision is a
 * ruling over the verdict with its reason, or an amendment made while Not
 * novel stood, which the last amendment's recorded verdict says. A ruling with
 * no reason was given over another verdict, so it is not the decision.
 * Removing the position is the third, and leaves nothing to confirm.
 */
export function needsDecision(
  position: PositionAnalysisResponse,
  attorney: PositionResponse | undefined,
): boolean {
  if (position.verdict !== "not_novel") return false;
  if (attorney === undefined) return true;
  if (attorney.verdict_override_reason !== null) return false;
  const last = attorney.amendments.at(-1);
  return last?.verdict_when_amended !== "not_novel";
}

/** What a held Confirm says it waits on. */
export const NEEDS_DECISION =
  "Amend, remove or override this position before you confirm it.";
